const Snmp = () => import(/* webpackChunkName: "v-gateway-conf" */ '@/components/page/gateway/configurations/Snmp')
const Alarms = () => import(/* webpackChunkName: "v-gateway-conf" */ '@/components/page/gateway/configurations/Alarms')
const Clock = () => import(/* webpackChunkName: "v-gateway-conf" */ '@/components/page/gateway/configurations/Clock')
const Vpn = () => import(/* webpackChunkName: "v-gateway-conf" */ '@/components/page/gateway/configurations/Vpn')
const Backhaul = () => import(/* webpackChunkName: "v-gateway-conf" */ '@/components/page/gateway/configurations/Backhaul')
const Radio = () => import(/* webpackChunkName: "v-gateway-conf" */ '@/components/page/gateway/configurations/radio/Radio')
const Geolocation = () => import(/* webpackChunkName: "v-gateway-conf" */ '@/components/page/gateway/configurations/Geolocation')
const Software = () => import(/* webpackChunkName: "v-gateway-conf" */ '@/components/page/gateway/configurations/software/Software')
const History = () => import(/* webpackChunkName: "v-gateway-conf" */ '@/components/page/gateway/configurations/History')

const routes = [
  {
    path: 'configurations',
    name: 'gatewayConf',
    redirect: 'configurations/snmp'
  }, {
    path: 'configurations/snmp',
    name: 'gatewayConfSnmp',
    component: Snmp,
    props: true,
    meta: {
      roles: ['SUPER_ADMIN'],
      dropdown: 'configurations'
    }
  }, {
    path: 'configurations/alarms',
    name: 'gatewayConfAlarms',
    component: Alarms,
    props: true,
    meta: {
      roles: ['ADMIN', 'SUPER_ADMIN'],
      dropdown: 'configurations'
    }
  }, {
    path: 'configurations/clock',
    name: 'gatewayConfClock',
    component: Clock,
    props: true,
    meta: {
      roles: ['ADMIN', 'SUPER_ADMIN'],
      dropdown: 'configurations'
    }
  }, {
    path: 'configurations/vpn',
    name: 'gatewayConfVpn',
    component: Vpn,
    props: true,
    meta: {
      roles: ['SUPER_ADMIN'],
      dropdown: 'configurations'
    }
  }, {
    path: 'configurations/backhaul',
    name: 'gatewayConfBackhaul',
    component: Backhaul,
    props: true,
    meta: {
      roles: ['ADMIN', 'SUPER_ADMIN'],
      dropdown: 'configurations'
    }
  }, {
    path: 'configurations/radio',
    name: 'gatewayConfRadio',
    component: Radio,
    props: true,
    meta: {
      roles: ['ADMIN', 'SUPER_ADMIN'],
      dropdown: 'configurations'
    }
  }, {
    path: 'configurations/geolocation',
    name: 'gatewayConfGeolocation',
    component: Geolocation,
    props: true,
    meta: {
      roles: ['ADMIN', 'SUPER_ADMIN'],
      dropdown: 'configurations',
      hasFloatingButton: true
    }
  }, {
    path: 'configurations/software',
    name: 'gatewayConfSoftware',
    component: Software,
    props: true,
    meta: {
      roles: ['ADMIN', 'SUPER_ADMIN'],
      dropdown: 'configurations'
    }
  }, {
    path: 'configurations/history',
    name: 'gatewayConfHistory',
    component: History,
    props: true,
    meta: {
      roles: ['ADMIN', 'SUPER_ADMIN'],
      dropdown: 'configurations'
    }
  }
]

export default routes
